import React from 'react';
interface Column<T> {
  key: string;
  header: string;
  render?: (item: T) => ReactNode;
  className?: string;
}
interface TableProps<T> {
  columns: Column<T>[];
  data: T[];
  keyExtractor: (item: T) => string;
  onRowClick?: (item: T) => void;
  emptyMessage?: string;
  isLoading?: boolean;
}
export function Table<T>({
  columns,
  data,
  keyExtractor,
  onRowClick,
  emptyMessage = 'No data available',
  isLoading = false
}: TableProps<T>) {
  if (isLoading) {
    return <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-256">
        <div className="animate-pulse" data-id="element-257">
          <div className="h-12 bg-gray-100 border-b border-gray-200" data-id="element-258" />
          {[...Array(5)].map((_, i) => <div key={i} className="h-16 border-b border-gray-100 flex items-center px-6 gap-4" data-id="element-259">
              <div className="h-4 bg-gray-200 rounded w-1/4" data-id="element-260" />
              <div className="h-4 bg-gray-200 rounded w-1/3" data-id="element-261" />
              <div className="h-4 bg-gray-200 rounded w-1/4" data-id="element-262" />
            </div>)}
        </div>
      </div>;
  }
  if (data.length === 0) {
    return <div className="bg-white rounded-lg border border-gray-200 p-12 text-center" data-id="element-263">
        <p className="text-gray-500" data-id="element-264">{emptyMessage}</p>
      </div>;
  }
  return <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-265">
      <div className="overflow-x-auto" data-id="element-266">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-267">
          <thead className="bg-gray-50" data-id="element-268">
            <tr data-id="element-269">
              {columns.map(column => <th key={column.key} scope="col" className={`
                    px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider
                    ${column.className || ''}
                  `} data-id="element-270">
                  {column.header}
                </th>)}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-271">
            {data.map(item => <tr key={keyExtractor(item)} onClick={() => onRowClick?.(item)} className={`
                  ${onRowClick ? 'cursor-pointer hover:bg-gray-50' : ''}
                  transition-colors duration-150
                `} data-id="element-272">
                {columns.map(column => <td key={`${keyExtractor(item)}-${column.key}`} className={`
                      px-6 py-4 whitespace-nowrap text-sm text-gray-900
                      ${column.className || ''}
                    `} data-id="element-273">
                    {column.render ? column.render(item) : (item as Record<string, unknown>)[column.key] as ReactNode}
                  </td>)}
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}